import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11adb3a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-info-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-title" }, "所属部门：", -1))
const _hoisted_3 = { class: "item-value" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-title" }, "提交人员：", -1))
const _hoisted_5 = { class: "item-value" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-title" }, "提交时间：", -1))
const _hoisted_7 = { class: "item-value" }

import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  StaffInfo: {
    type: Object,
    default: {
      company_froms: {
        cf_name: '--'
      },
      name: '--',
      currentTime: '--'
    }
  }
},
  setup(__props) {

const props = __props


const StaffInfo = ref({})
watch(props, (newValue, oldValue) => {
  console.log('watch 已触发', newValue)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, _toDisplayString(props.StaffInfo?.company_froms.cf_name), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(props.StaffInfo?.name), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, _toDisplayString(props.StaffInfo?.currentTime), 1)
      ])
    ])
  ]))
}
}

})